import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
// import { useContext } from 'react';
import { FaRegWindowClose } from 'react-icons/fa';
import { baseUrl } from '../../utils/baseUrl.js';
import { toast } from 'react-toastify';
import Joi from 'joi';
// import { CheckOutContext } from '../../Context/CheckOutContext.jsx';

const OrderModal = ({ visible, onClose, productId, quantity }) => {
    const [paymentMethod, setPaymentMethod] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [errorList, setErrorList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    let token = localStorage.getItem('authorization')
    const notify = (msg, type) => toast[type](msg);
    const [order, setOrder] = useState({
        address: '',
        phone: '',
        paymentMethod: '',
        couponCode: '',
        products: [
            {
                productId: '',
                quantity: '',
            }
        ],
    })
    if (!visible) return null
    const handleCloseModalById = (e) => {
        if (e.target.id === "modal")
            onClose();
    }
    const getInputValues = (e) => {
        let newOrder = { ...order }
        newOrder[e.target.name] = e.target.value;
        setOrder(newOrder);
    }

    const products = [
        {
            productId,
            quantity
        }
    ]
    order.products = products
    order.paymentMethod = paymentMethod

    function submitForm(e) {
        e.preventDefault();//to prevent reload.
        if (!order.couponCode) {
            delete order.couponCode
        }
        let validationResult = validation();
        if (validationResult.error) {
            setIsLoading(false);
            setErrorList(validationResult.error.details);
        } else {
            makeCheckout(order)
        }
    }

    const makeCheckout = async (values) => {
        setIsLoading(true)
        await axios(`${baseUrl}/orders`, {
            method: 'post',
            headers: {
                'Authorization': `ecomm__${token}`
            },
            data: values
        }).then((response) => {
            if (response.status === 201) {
                if (response.data?.order?.paymentMethod === 'card') {
                    window.open(response.data?.session?.url)
                } else if (response.data?.order.paymentMethod === 'cash') {
                    notify("Successful Order", "success")
                }
                setIsLoading(true)
            }
        }).catch((error) => {
            if (error.response.data) {
                setErrorMessage(error.response.data.error)
                notify(error.response.data.error, "error")
            }
            if (error.response?.data?.Errors?.length) {
                error.response.data.Errors.map((err) =>
                    setErrorList(err)
                )
            }
        })
    }

    function validation() {
        let validationSchema = Joi.object({
            address: Joi.string().required().min(10),
            couponCode: Joi.string().optional(),
            phone: Joi.string().required().regex(/^(\+201|01|00201)[0-2,5]{1}[0-9]{8}/, 'must be a valid number'),
            paymentMethod: Joi.string().required(),
            products: Joi.array()
            // products: Joi.array().items(Joi.object({
            //     product: Joi.string().required,
            //     quantity: Joi.number().required
            // })).required()
        });
        return validationSchema.validate(order, { abortEarly: false })
    }


    return (
        <div id="modal" onClick={handleCloseModalById} className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="bg-white p-2 rounded w-11/12 sm:w-9/12 lg:w-8/12 relative">
                <button onClick={onClose} className='absolute right-2 text-red-600 hover:text-red-500'><FaRegWindowClose size={24} /></button>
                <h1 className="font-semibold text-center text-xl text-gray-700 my-3">Order Product</h1>
                <hr />
                {errorMessage ? <p className="p-3 text-center text-lg bg-red-500 border border-red-600 ">{errorMessage}</p> : ""}
                <form onSubmit={submitForm} className="flex flex-col my-4">
                    <div className="my-2">
                        <input onChange={getInputValues} type="text" name='address' className="w-full p-3 border border-gray-500 rounded text-lg focus:outline-blue-400" placeholder="Address" />
                        {errorList.filter((err) => err.context.label === 'address')[0] ? <div className="text-red-500 p-2 my-1">
                            <p className="m-0">{errorList.filter((err) => err.context.label === 'address')[0]?.message}</p>
                        </div> : ''}
                    </div>
                    <div className="my-2">
                        <input onChange={getInputValues} type="text" name='phone' className="w-full p-3 border border-gray-500 rounded text-lg focus:outline-blue-400" placeholder="Phone" />
                        {errorList.filter((err) => err.context.label === 'phone')[0] ? <div className="text-red-500 p-2 my-1">
                            <p className="m-0">{errorList.filter((err) => err.context.label === 'phone')[0]?.message}</p>
                        </div> : ''}
                    </div>
                    <div className="my-2">
                        <input onChange={getInputValues} type="text" name='couponCode' className="w-full p-3 border border-gray-500 rounded text-lg focus:outline-blue-400" placeholder="Coupon" />
                    </div>
                    <div className="my-2">
                        <FormControl>
                            <InputLabel id="demo-simple-select-label">Payment Method</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name='paymentMethod'
                                label="Payment Method"
                                value={paymentMethod}
                                onChange={(e) => setPaymentMethod(e.target.value)}
                                className="text-center text-base w-44"
                            >
                                <MenuItem value={"cash"}>Cash</MenuItem>
                                <MenuItem value={"card"}>Card</MenuItem>
                            </Select>
                        </FormControl>
                        {errorList.filter((err) => err.context.label === 'paymentMethod')[0] ? <div className="text-red-500 p-2 my-1">
                            <p className="m-0">{errorList.filter((err) => err.context.label === 'paymentMethod')[0]?.message}</p>
                        </div> : ''}
                    </div>
                    <button type='submit' className="bg-amber-600 p-3 px-8 rounded text-white hover:bg-amber-500 transition"> {!isLoading ? "Order" : "Loading"}</button>
                </form>
            </div>
        </div>
    )
}

export default OrderModal